import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';
import { SubscriptionPlan } from '@client/features/subscription-plan/models/subscription-plan';

export class Workspace {
  constructor(
    public readonly id: number,
    public readonly uuid: string,
    public readonly ownerId: number,
    public readonly ownerEmail: string,
    public readonly subscriptionPlan: Nullable<SubscriptionPlan>,
    public readonly allowsNewProjects: boolean,
    public readonly onTrial: boolean,
    public readonly remainingDaysOnTrial: number,
  ) {}
}

defineTransform(Workspace, (json, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    subscriptionPlan: nullOr(json.subscription_plan, () => fromJson(SubscriptionPlan, json.subscription_plan)),
  };
});
